export default __webpack_public_path__ + "static/media/IBM_logo.527b40d4.png";